import { useState, useEffect } from 'react';

/**
 * Возвращает флаг, показывающий, что первый рендер компонент прошёл
 * */
const useAfterMountRenderer = (deps = true): boolean => {
  const [isRendered, setIsRendered] = useState<boolean>(false);

  useEffect(() => {
    if (deps) {
      setIsRendered(true);
    }
  }, [deps]);

  return isRendered;
};

export default useAfterMountRenderer;
